import { render, staticRenderFns } from "./SideNavNav.vue?vue&type=template&id=1a188053&scoped=true&"
import script from "./SideNavNav.vue?vue&type=script&lang=js&"
export * from "./SideNavNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a188053",
  null
  
)

export default component.exports